module.exports = __webpack_public_path__ + "img/jpg.bb89277.svg";